import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  WORK_PLAN_ASSIGNED_ALL,
  WORK_PLAN_CREATE,
  WORK_PLAN_CREATED_ALL,
  WORK_PLAN_DELETE,
  WORK_PLAN_STAFF_LIST,
  WORK_PLAN_UPDATE,
  WORK_PLAN_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const workPlanCreate = createAsyncThunk(
  WORK_PLAN_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.WORK_PLAN}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.workPlanCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanDelete = createAsyncThunk(
  WORK_PLAN_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.WORK_PLAN}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.workPlanDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanUpdate = createAsyncThunk(
  WORK_PLAN_UPDATE,
  async (params: PayloadCreatorParams<`${typeof API.WORK_PLAN_UPDATE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.workPlanUpdate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanUpdateStatus = createAsyncThunk(
  WORK_PLAN_UPDATE_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.WORK_PLAN_UPDATE_STATUS}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.workPlanUpdateStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanCreatedAll = createAsyncThunk(
  WORK_PLAN_CREATED_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.WORK_PLAN_CREATED_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.workPlanCreatedAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanAssignedAll = createAsyncThunk(
  WORK_PLAN_ASSIGNED_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.WORK_PLAN_ASSIGNED_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.workPlanAssignedAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanStaffList = createAsyncThunk(
  WORK_PLAN_STAFF_LIST,
  async (
    params: PayloadCreatorParams<`${typeof API.WORK_PLAN_STAFF_LIST}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.workPlanStaffList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const workPlanAssignedAllClear = createAction(`${WORK_PLAN_ASSIGNED_ALL}/clear`)

export const workPlanCreatedAllClear = createAction(`${WORK_PLAN_CREATED_ALL}/clear`)

export const workPlanStaffListClear = createAction(`${WORK_PLAN_STAFF_LIST}/clear`)
